import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { NotaireProvider } from "./services/notaireProvider";
import { MemberstackProvider } from "./context/MemberstackContext";
import { ToastContainer } from "react-toastify";
import ClotereComptables from './ClotereComptables';
import ChecklistVisibilite from './ChecklistVisibilite';
import Connexion from './Connexion';
import Layout from './app/Layout';
import Affaire from './app/Affaire';
import OnboardStep1 from './app/onboard/OnboardStep1';
import OnboardStep2 from './app/onboard/OnboardStep2';
import OnboardStep3Abonnement from './app/onboard/OnboardStep3Abonnement';
import OnboardEnd from './app/onboard/OnboardEnd';
import EndAbonnement from './app/EndAbonnement';

const App = () => (
  <MemberstackProvider>
    <Router>
      <Routes>
        <Route path="/" element={<ClotereComptables />} />
        <Route path="/checklist-visibilite" element={<ChecklistVisibilite />} />
        <Route path="/connexion" element={<Connexion />} />

        <Route
          path="/app/*"
          element={
            <NotaireProvider>
              <Routes>
                <Route path="dashboard" element={<Layout />} />
                <Route path="affaires" element={<Layout />} />
                <Route path="profil" element={<Layout />} />
                <Route path="fiche" element={<Layout />} />
                <Route path="demande-contact" element={<Layout />} />
                <Route path="rendez-vous" element={<Layout />} />
                <Route path="support" element={<Layout />} />
                <Route path="widget-rdv" element={<Layout />} />
                <Route path="calendrier" element={<Layout />} />
                <Route path="messagerie" element={<Layout />} />
                <Route path="parametres" element={<Layout />} />
                <Route path="parametres/calendrier" element={<Layout />} />
                <Route path="affaire/:type/:id" element={<Affaire />} />
                <Route path="end-abonnement" element={<EndAbonnement />} />
                <Route path="onboard-notaire/informations" element={<OnboardStep1 />} />
                <Route path="onboard-notaire/fiche" element={<OnboardStep2 />} />
                <Route path="onboard-notaire/abonnement" element={<OnboardStep3Abonnement />} />
                <Route path="onboard-notaire/end" element={<OnboardEnd />} />
              </Routes>
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
            </NotaireProvider>
          }
        />

        <Route path="*" element={<ClotereComptables />} />
      </Routes>
    </Router>
  </MemberstackProvider>
);

export default App;
